(() => {
'use strict';
const customerLabels = { business: window.FlexxesText("Bedrijf of organisatie"), private: window.FlexxesText("Particulier") };
const kindLabels = {
  event: window.FlexxesText("Een compleet event"), rental: window.FlexxesText("Apparatuur met service"),
  installation: window.FlexxesText("Een vaste installatie"), advice: window.FlexxesText("Eerst advies")
};
const serviceLabels = {
  audio: window.FlexxesText("Geluid & microfoons"), video: window.FlexxesText("Schermen & projectie"), light: window.FlexxesText("Licht & sfeer"),
  stream: window.FlexxesText("Livestream & opname"), stage: window.FlexxesText("Podium"), shelter: window.FlexxesText("Konligo-overkapping"),
  dj: window.FlexxesText("DJ gear"), booth: window.FlexxesText("LED-dj-booth"), meeting: window.FlexxesText("Videovergaderen"),
  control: window.FlexxesText("Eenvoudige bediening"), advice: window.FlexxesText("Adviseer mij")
};
const supportLabels = {
  delivery: window.FlexxesText("Leveren en ophalen"), setup: window.FlexxesText("Ook opbouwen, aansluiten en testen"),
  production: window.FlexxesText("Complete uitvoering en technische begeleiding"), advice: window.FlexxesText("Graag samen bepalen")
};
const stepLabels = [window.FlexxesText("Jouw vraag"), window.FlexxesText("De details"), window.FlexxesText("De techniek"), window.FlexxesText("Contact"), window.FlexxesText("Overzicht")];

function activeServices(kind) {
  return kind === 'installation'
    ? ['audio', 'video', 'meeting', 'control', 'advice']
    : ['audio', 'video', 'light', 'stream', 'stage', 'shelter', 'dj', 'booth', 'advice'];
}

function localDate(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

function validateStep(step, data, today = localDate()) {
  const empty = key => !String(data[key] ?? '').trim();
  const error = (field, message) => ({ field, message });
  if (step === 0) {
    if (!Object.hasOwn(customerLabels, data.customerType)) return error('customerType', window.FlexxesText("Kies of je zakelijk of als particulier aanvraagt."));
    if (!Object.hasOwn(kindLabels, data.kind)) return error('kind', window.FlexxesText("Kies eerst waarmee we je kunnen helpen."));
  }
  if (step === 1) {
    if (data.kind === 'installation') {
      if (empty('roomType')) return error('roomType', window.FlexxesText("Kies het type ruimte."));
      if (empty('timing')) return error('timing', window.FlexxesText("Geef aan wanneer je dit wilt realiseren."));
    } else {
      if (empty('eventType')) return error('eventType', window.FlexxesText("Kies het soort bijeenkomst, of kies ‘Nog niet bekend’."));
      if (!data.dateUnknown) {
        const parsed = new Date(`${data.date}T12:00:00`);
        if (!/^\d{4}-\d{2}-\d{2}$/.test(data.date ?? '') || Number.isNaN(parsed.valueOf()) || localDate(parsed) !== data.date) return error('date', window.FlexxesText("Vul een geldige datum in of kies ‘Datum nog niet bekend’."));
        if (data.date < today) return error('date', window.FlexxesText("Kies vandaag of een datum in de toekomst."));
      }
      if (empty('guests')) return error('guests', window.FlexxesText("Kies het aantal gasten, of kies ‘Nog niet bekend’."));
    }
    if (!data.locationUnknown && empty('location')) return error('location', window.FlexxesText("Vul een locatie in of kies ‘Locatie nog niet bekend’."));
  }
  if (step === 2) {
    const selected = (data.services ?? []).filter(value => activeServices(data.kind).includes(value));
    if (!selected.length) return error('services', window.FlexxesText("Kies minimaal één onderdeel, of kies ‘Adviseer mij’."));
    if (data.kind !== 'installation' && !Object.hasOwn(supportLabels, data.support)) return error('support', window.FlexxesText("Kies de gewenste ondersteuning, of kies ‘Graag samen bepalen’."));
    if (!empty('budget') && (!Number.isFinite(Number(data.budget)) || Number(data.budget) < 0)) return error('budget', window.FlexxesText("Vul een geldig budget vanaf € 0 in, of laat het veld leeg."));
  }
  if (step === 3) {
    if (empty('name')) return error('name', window.FlexxesText("Vul je naam in."));
    if (data.customerType === 'business' && empty('company')) return error('company', window.FlexxesText("Vul je bedrijf of organisatie in."));
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(data.email ?? '').trim())) return error('email', window.FlexxesText("Vul een geldig e-mailadres in, bijvoorbeeld alex@example.com."));
    if (!empty('phone')) {
      const phone = String(data.phone).trim();
      const digits = phone.replace(/\D/g, '');
      if (!/^[+\d\s().-]+$/.test(phone) || digits.length < 8 || digits.length > 15) return error('phone', window.FlexxesText("Controleer je telefoonnummer, of laat dit optionele veld leeg."));
    }
  }
  return null;
}

function summarySections(data) {
  const details = data.kind === 'installation'
    ? [[window.FlexxesText("Ruimte"), window.FlexxesText(data.roomType)], [window.FlexxesText("Planning"), window.FlexxesText(data.timing)]]
    : [[window.FlexxesText("Bijeenkomst"), window.FlexxesText(data.eventType)], [window.FlexxesText("Datum"), data.dateUnknown ? window.FlexxesText("Nog niet bekend") : new Intl.DateTimeFormat((document.documentElement.lang.startsWith('nl')?'nl-NL':'en-US'), { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(`${data.date}T12:00:00`))], [window.FlexxesText("Aantal gasten"), window.FlexxesText(data.guests)]];
  details.push([window.FlexxesText("Locatie"), data.locationUnknown ? window.FlexxesText("Nog niet bekend") : data.location]);
  const technical = [
    [window.FlexxesText("Onderdelen"), (data.services ?? []).filter(key => activeServices(data.kind).includes(key)).map(key => serviceLabels[key]).join(', ')],
    [window.FlexxesText("Uitvoering"), data.kind === 'installation' ? window.FlexxesText("Samen afstemmen: advies, installatie en uitleg") : supportLabels[data.support]],
    [window.FlexxesText("Richtbudget"), data.budget === '' || data.budget == null ? window.FlexxesText("Nog niet bepaald") : new Intl.NumberFormat((document.documentElement.lang.startsWith('nl')?'nl-NL':'en-US'), { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(Number(data.budget)) + (data.budgetVat === 'included' ? window.FlexxesText(" incl. btw") : window.FlexxesText(" excl. btw"))]
  ];
  if (data.equipment?.length) technical.unshift([window.FlexxesText("Voorkeur apparatuur"), data.equipment.join(', ')]);
  if(data.estimate)technical.push([window.FlexxesText("Indicatie apparatuur / 24 uur"), new Intl.NumberFormat((document.documentElement.lang.startsWith('nl')?'nl-NL':'en-US'),{style:'currency',currency:'EUR'}).format(data.estimate.ex/100)+window.FlexxesText(" excl. btw / ")+new Intl.NumberFormat((document.documentElement.lang.startsWith('nl')?'nl-NL':'en-US'),{style:'currency',currency:'EUR'}).format(data.estimate.inc/100)+window.FlexxesText(" incl. 21% btw")],[window.FlexxesText("Nog te offreren"),(data.estimate.unknown?window.FlexxesText("Onderdelen op aanvraag; "):'')+window.FlexxesText("transport, opbouw, afbouw, begeleiding en aanvullend bevestigingsmateriaal. De offerte is leidend.")]);
  if (data.notes?.trim()) technical.push([window.FlexxesText("Toelichting"), data.notes.trim()]);
  const contact = [[window.FlexxesText("Naam"), data.name]];
  if (data.customerType === 'business') contact.push([window.FlexxesText("Organisatie"), data.company]);
  contact.push([window.FlexxesText("E-mail"), data.email]);
  if (data.phone?.trim()) contact.push([window.FlexxesText("Telefoon"), data.phone.trim()]);
  return [
    { title: window.FlexxesText("Jouw vraag"), step: 0, items: [[window.FlexxesText("Aanvrager"), customerLabels[data.customerType]], [window.FlexxesText("Aanvraag"), kindLabels[data.kind]]] },
    { title: window.FlexxesText("De details"), step: 1, items: details },
    { title: window.FlexxesText("De techniek"), step: 2, items: technical },
    { title: window.FlexxesText("Contact"), step: 3, items: contact }
  ];
}

function requestMessage(data, requestId) {
  const brief = window.FlexxesText("FLEXXES OFFERTEAANVRAAG\nReferentie: ") + requestId + '\n\n' + summarySections(data).map(section => section.title.toUpperCase() + '\n' + section.items.map(([key, value]) => `${key}: ${value || window.FlexxesText("Nog niet bekend")}`).join('\n')).join('\n\n') + window.FlexxesText("\n\nLevering en ophalen op locatie. Dit is een vrijblijvende aanvraag, geen reservering. Beschikbaarheid, uitvoering en prijs stemmen we samen af.");
  return `[FX_LANG]\n${document.documentElement.lang.startsWith('en')?'en':'nl'}\n[/FX_LANG]\n[FX_EMAIL]\n${data.email}\n[/FX_EMAIL]\n[FX_REF]\n${requestId}\n[/FX_REF]\n[FX_BRIEF]\n${brief}\n[/FX_BRIEF]`;
}

function initIntake(root) {
  if (root.dataset.fxReady) return;
  root.dataset.fxReady='true';
  const q = id => root.querySelector(`[data-fx-id="${id}"]`);
  const form=root.querySelector('[data-fx-form]');
  const mode=root.dataset.mode;
  const quote=window.FlexxesQuote;
  if(!form||!quote)return;
  const serverSuccess=root.querySelector('[data-fx-success]');
  if(serverSuccess){
    quote.clear();q('intake-progress-wrap').hidden=true;
    root.querySelectorAll('.intake-steps li').forEach(item=>{item.removeAttribute('aria-current');item.classList.add('is-complete');});
    serverSuccess.focus({preventScroll:true});return;
  }
  const field = name => form.elements.namedItem(['name','company','email','phone'].includes(name)?`contact[${name}]`:name);
  const steps=[...form.querySelectorAll('[data-step]')];
  const back=q('intake-back'),next=q('intake-next'),nextLabel=q('intake-next-label'),errorNode=q('intake-error'),progress=q('intake-progress'),complete=q('intake-complete'),exampleStatus=q('example-status');
  // Keep navigation safe even while this asset and the Liquid section update separately.
  next.type='button';
  const sideSteps=[...root.querySelectorAll('.intake-steps li')];
  let currentStep=0,furthestStep=0,finished=false;
  const requestId='FX-'+(window.crypto?.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2,12)}`).toUpperCase();

  function getData(){
    const values=new FormData(form);
    const data=Object.fromEntries([...values.entries()].map(([key,value])=>[key.replace(/^contact\[([^\]]+)\]$/,'$1'),value]));
    data.services=values.getAll('services');
    data.dateUnknown=values.has('dateUnknown');data.locationUnknown=values.has('locationUnknown');
    data.equipment=quote.read().map(quote.label);
    data.estimate=quote.read().length?quote.totals():null;
    for(const key of ['date','location','budget','notes','phone','name','company','email'])data[key]=String(data[key]??'').trim();
    if(data.customerType==='private')data.company='';
    return data;
  }
  function updateConditional(){
    const kind=field('kind').value||'event';
    for(const group of form.querySelectorAll('[data-scope]')){
      const visible=group.dataset.scope.split(',').includes(kind);group.hidden=!visible;
      group.querySelectorAll('input,select,textarea').forEach(input=>{input.disabled=!visible;});
    }
    field('date').disabled=kind==='installation'||field('dateUnknown').checked;
    field('location').disabled=field('locationUnknown').checked;
    const business=field('customerType').value==='business';
    q('company-field').hidden=!business;field('company').disabled=!business;field('company').required=business;
    q('details-title').textContent=kind==='installation'?window.FlexxesText("Vertel ons over je ruimte."):window.FlexxesText("Wat zijn je plannen?");
    q('details-description').textContent=kind==='installation'?window.FlexxesText("Waar wil je geluid en beeld inzetten? Een eerste indruk is genoeg."):window.FlexxesText("Vertel wat je al weet. Details stemmen we later samen af.");
  }
  function clearError(){
    errorNode.hidden=true;errorNode.textContent='';
    form.querySelectorAll('[aria-invalid]').forEach(input=>{
      input.removeAttribute('aria-invalid');
      const ids=(input.getAttribute('aria-describedby')||'').split(' ').filter(id=>id&&id!==errorNode.id);
      if(ids.length)input.setAttribute('aria-describedby',ids.join(' '));else input.removeAttribute('aria-describedby');
    });
  }
  function showError(error){
    errorNode.textContent=error.message;errorNode.hidden=false;
    const name=['name','company','email','phone'].includes(error.field)?`contact[${error.field}]`:error.field;
    const input=[...form.querySelectorAll('input,select,textarea')].find(input=>input.name===name&&!input.disabled);
    if(input){input.setAttribute('aria-invalid','true');input.setAttribute('aria-describedby',`${input.getAttribute('aria-describedby')||''} ${errorNode.id}`.trim());input.focus();}
  }
  function renderSummary(){
    const sections=summarySections(getData()),container=q('intake-summary');container.replaceChildren();
    for(const section of sections){
      const card=document.createElement('section');card.className='summary-card';
      const header=document.createElement('div');header.className='summary-card-header';
      const title=document.createElement('h4');title.textContent=section.title;
      const edit=document.createElement('button');edit.type='button';edit.textContent=window.FlexxesText("Wijzigen");edit.setAttribute('aria-label',window.FlexxesText("${0} wijzigen", section.title));edit.addEventListener('click',()=>goToStep(section.step));header.append(title,edit);
      const list=document.createElement('dl');
      for(const [label,value] of section.items){const term=document.createElement('dt'),definition=document.createElement('dd');term.textContent=label;definition.textContent=value||window.FlexxesText("Nog niet bekend");list.append(term,definition);}
      card.append(header,list);container.append(card);
    }
    form.querySelector('[data-fx-brief]').value=requestMessage(getData(),requestId);
  }
  function focusStep(heading){
    heading.focus({preventScroll:true});
    const top=root.querySelector('.intake-shell').getBoundingClientRect().top+window.scrollY;
    window.scrollTo({top:Math.max(0,top-120),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  function goToStep(step,focus=true){
    currentStep=Math.max(0,Math.min(4,step));furthestStep=Math.max(furthestStep,currentStep);finished=false;
    root.querySelector('[data-fx-wizard]').hidden=false;if(complete)complete.hidden=true;q('intake-progress-wrap').hidden=false;
    steps.forEach((node,index)=>{node.hidden=index!==currentStep;});clearError();updateConditional();
    back.hidden=currentStep===0;progress.value=currentStep+1;
    q('intake-counter').textContent=window.FlexxesText("Stap ${0} van 5", currentStep+1);q('intake-stage-label').textContent=stepLabels[currentStep];
    nextLabel.textContent=currentStep===4?(mode==='demo'?window.FlexxesText("Demo afronden"):window.FlexxesText("Verstuur je aanvraag")):(furthestStep===4?window.FlexxesText("Verder naar overzicht"):window.FlexxesText("Verder"));
    sideSteps.forEach((item,index)=>{if(index===currentStep)item.setAttribute('aria-current','step');else item.removeAttribute('aria-current');item.classList.toggle('is-complete',index<currentStep);});
    quote.render(root);if(currentStep===4)renderSummary();if(focus)focusStep(steps[currentStep].querySelector('h3'));
  }
  function validateAll(){
    const invalidQuantity=root.querySelector('[data-fx-quote-list] input:invalid');
    if(invalidQuantity){goToStep(2);errorNode.textContent=window.FlexxesText("Kies voor elk product een heel aantal van 1 tot en met 100.");errorNode.hidden=false;invalidQuantity.reportValidity();return false;}
    const data=getData();
    for(let step=0;step<4;step++){const error=validateStep(step,data);if(error){goToStep(step);showError(error);return false;}}
    return true;
  }
  function prefillQuote(){
    const selected=quote.read();
    if(selected.length&&!field('kind').value)field('kind').value='rental';
    updateConditional();
    for(const input of form.querySelectorAll('[name="services"]')){
      if(selected.some(item=>item.service===input.value)&&!input.disabled)input.checked=true;
    }
    const checked=[...form.querySelectorAll('[name="services"]:checked')].filter(input=>!input.disabled);
    if(checked.some(input=>input.value!=='advice'))form.querySelector('[name="services"][value="advice"]').checked=false;
  }
  function prepareSubmission(){
    if(!validateAll())return false;
    const data=getData();
    for(const name of ['name','company','email','phone'])field(name).value=data[name];
    renderSummary();
    return true;
  }
  function advance(){
    if(finished)return;
    const invalidQuantity=root.querySelector('[data-fx-quote-list] input:invalid');
    if(currentStep===2&&invalidQuantity){errorNode.textContent=window.FlexxesText("Kies voor elk product een heel aantal van 1 tot en met 100.");errorNode.hidden=false;invalidQuantity.reportValidity();return;}
    clearError();const error=validateStep(currentStep,getData());
    if(error){showError(error);return;}
    if(currentStep===4){
      if(!prepareSubmission())return;
      if(mode==='demo'){
        root.querySelector('[data-fx-wizard]').hidden=true;q('intake-progress-wrap').hidden=true;complete.hidden=false;finished=true;
        sideSteps.forEach(item=>{item.removeAttribute('aria-current');item.classList.add('is-complete');});
        const data=getData();q('completed-brief').textContent=`${data.company||data.name} · ${kindLabels[data.kind]} · ${data.locationUnknown?window.FlexxesText("Locatie nog te bepalen"):data.location}`;
        focusStep(complete.querySelector('h3'));
      }else{
        // Emit the first native submit only after the visitor confirms the valid overview.
        // requestSubmit preserves Shopify's submit handlers and spam protection.
        form.requestSubmit();
      }
      return;
    }
    if(furthestStep===4){if(validateAll())goToStep(4);}else goToStep(currentStep+1);
  }
  next.addEventListener('click',event=>{event.preventDefault();advance();});
  form.addEventListener('keydown',event=>{
    if(event.key!=='Enter'||event.isComposing||event.ctrlKey||event.altKey||event.metaKey||event.shiftKey)return;
    if(event.target.tagName!=='INPUT'||['button','submit','reset'].includes(event.target.type))return;
    event.preventDefault();advance();
  });
  form.addEventListener('submit',event=>{
    if(currentStep!==4||mode==='demo'||!prepareSubmission())event.preventDefault();
    // A valid final submission stays native. Only Liquid confirms server success.
  });
  back.addEventListener('click',()=>goToStep(currentStep-1));
  form.addEventListener('input',clearError);
  form.addEventListener('change',event=>{
    clearError();
    if(event.target.name==='services'&&event.target.checked){
      form.querySelectorAll('[name="services"]').forEach(option=>{if(event.target.value==='advice'&&option!==event.target)option.checked=false;else if(event.target.value!=='advice'&&option.value==='advice')option.checked=false;});
    }
    if(event.target.name==='customerType'){
      if(!field('budget').value)field('budgetVat').value=field('customerType').value==='private'?'included':'excluded';
    }
    if(['kind','dateUnknown','locationUnknown','customerType'].includes(event.target.name))updateConditional();
  });
  q('intake-example')?.addEventListener('click',()=>{
    form.reset();quote.clear();const date=new Date();date.setDate(date.getDate()+42);
    const values={customerType:'business',budgetVat:'excluded',kind:'event',eventType:window.FlexxesText("Congres of seminar"),date:localDate(date),guests:window.FlexxesText("75 tot 150"),location:window.FlexxesText("Amsterdam, op ons kantoor"),support:'production',budget:'3500',name:window.FlexxesText("Alex Voorbeeld"),company:window.FlexxesText("Voorbeeld BV"),email:'alex@example.com',notes:window.FlexxesText("Een middagprogramma met drie sprekers en een panelgesprek, gevolgd door een netwerkborrel.")};
    Object.entries(values).forEach(([name,value])=>{field(name).value=value;});form.querySelectorAll('[name="services"]').forEach(input=>{input.checked=['audio','video','light'].includes(input.value);});
    furthestStep=0;goToStep(0);exampleStatus.textContent=window.FlexxesText("Fictieve voorbeeldgegevens zijn ingevuld. Deze demo verstuurt geen aanvraag.");exampleStatus.hidden=false;
  });
  q('intake-restart')?.addEventListener('click',()=>{form.reset();quote.clear();furthestStep=0;exampleStatus.hidden=true;goToStep(0);});
  q('intake-review')?.addEventListener('click',()=>goToStep(4));
  document.addEventListener('flexxes:quote-change',()=>{
    if(!root.isConnected)return;prefillQuote();if(currentStep===4&&!finished)renderSummary();
  });
  field('date').min=localDate();prefillQuote();next.disabled=false;goToStep(0,false);
}

function init(root=document){root.querySelectorAll('[data-fx-intake]').forEach(initIntake);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
document.addEventListener('shopify:section:load',event=>init(event.target));
})();
